export default __webpack_public_path__ + "media/images/dashboard_icons/bespoke-banners-37646556f21ecc629b945d3f9678b022.svg";